// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { wsc } from '../wsc';
import { Observable } from 'rxjs';

export class BrandLotteryModel {
  static listenBonusDrawAward(): Observable<string> {
    return wsc.subscribe('/ws/brand-lottery/listenBonusDrawAward') as any;
  }

  static listenIsWinner(): Observable<boolean> {
    return wsc.subscribe('/ws/brand-lottery/listenIsWinner') as any;
  }

  static listenIsFinished(): Observable<boolean> {
    return wsc.subscribe('/ws/brand-lottery/listenIsFinished') as any;
  }

  static bonusDraw(title: string): Promise<void> {
    return wsc.execute('/ws/brand-lottery/bonusDraw', title) as any;
  }

  static fetchIsWinner(): Promise<boolean> {
    return wsc.execute('/ws/brand-lottery/fetchIsWinner') as any;
  }

  static fetchIsFinished(): Promise<boolean> {
    return wsc.execute('/ws/brand-lottery/fetchIsFinished') as any;
  }

  static setWinner(winnerIdentifiers: string[]): Promise<void> {
    return wsc.execute('/ws/brand-lottery/setWinner', winnerIdentifiers) as any;
  }

  static setIsSpinExecuted(): Promise<void> {
    return wsc.execute('/ws/brand-lottery/setIsSpinExecuted') as any;
  }

  static isSpinExecuted(): Observable<boolean> {
    return wsc.subscribe('/ws/brand-lottery/isSpinExecuted') as any;
  }

  static fetchIsFilmstripExecuted(): Promise<boolean> {
    return wsc.execute('/ws/brand-lottery/fetchIsFilmstripExecuted') as any;
  }
}
// 2631402ea0ec1720288729592d0b5a40e09492ea15e8d1f217c0c1c097e5118c
